/**
 * The iframe app's SDK service: a game-agnostic pass-through. The parent lib
 * validates and posts GAME_EVENT envelopes for ANY game type, so the iframe
 * forwards raw (type, data) pairs instead of composing a typed per-game
 * service (BlackjackSDKService / RouletteSDKService).
 */

import { BaseSDKService } from '../sdk/BaseSDKService.js';

export class IframeSDKService extends BaseSDKService {
  /** Forward a pre-validated game-event envelope to the agent; resolves with the RPC verdict. */
  sendRawGameEvent(type: string, data?: unknown): Promise<{ success: boolean; error?: string }> {
    return this.dispatchWithResult(data === undefined ? { type } : { type, data });
  }
}
